exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item[data-v-136962e2] {\n    margin-bottom: 10px;\n    width: 100%;\n    text-align: left;\n    display: block;\n    padding-left: 6px;\n    padding-right: 30px;\n    box-sizing: border-box;\n}\n.item[data-v-136962e2]:last-of-type {\n    margin-bottom: 0;\n}\n.showAll[data-v-136962e2]:hover {\n    font-weight: bold;\n    cursor: pointer;\n}\n.clearBtn[data-v-136962e2] {\n    opacity: 0.3;\n}\n.clearBtn[data-v-136962e2]:hover {\n    opacity: 1;\n}\n.opahover[data-v-136962e2] {\n    opacity: 0.2;\n}\n.hover[data-v-136962e2]:hover {\n    opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-136962e2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FormItemEditor.vue
// module id = 6hcn
// module chunks = 142